import React, { useCallback, useEffect, useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import LayersIcon from "@mui/icons-material/Layers";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import checkcircleImage from "../../assests/images/check-circle.png";
import holdImage from "../../assests/images/hold.png";
import rejectImage from "../../assests/images/Reject.png";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import podetailImage from "../../assests/images/Po details.png";
import summaryImage from "../../assests/images/Summary.png";
import checkImage from "../../assests/images/check-circle.png";
import { UserObj } from "../../services/localStarage";
import Drawer from "@mui/material/Drawer";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import Stack from "@mui/material/Stack";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { getSecPermission, isEmptyDash, returnRateVal, returnZero, strToDate, totalInr, trimString } from "../../constant";
import AlertComponent from "../alert/alert";
import { Backdrop, CircularProgress } from "@mui/material";
import _ from "lodash";
import { purchaseOrderServices } from "../../services/purchaseOrderServices";
import topArrow from '../../assests/images/top.png';
import topHighlightArrow from '../../assests/images/top-highlighted.png';
import bottomArrow from '../../assests/images/bottom.png';
import bottomHighlightArrow from '../../assests/images/bottom-highlighted.png';
import { downloadFile } from "./index";
import { onboardingServices } from "../../services/onboardingServices";
import RequestSignModal from './requestSignModal';
import PDFPreview from "./pdfPreview";
import { vendorServices } from "../../services/vendorServices";
import POReleaseModal from "./releaseModal";
import TrackOrder from "../common/trackOrder";
import SupportChat from "../support/chat";
import Tooltip from '@mui/material/Tooltip';

const requestesignstyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "35%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const extendvaliditystyle1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const initialColumns = [
  { id: "productNumber", label: "Material Number", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "productNumber", label: "Service Number", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "description", label: "Material Description", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "description", label: "Service Description", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "itemNumber", label: "Item No.", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "unit", label: "Unit", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "totalQuantity", label: "Total Quantity", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "deliveredQty", label: "Recieved Quantity", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "pendingQty", label: "Pending Quantity", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },  
  
  { id: "qcQty", label: "QC Qty", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },  
  { id: "inTransitQty", label: "In-transit", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "balanceQty", label: "Balance Qty", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },

  { id: "plantName", label: "Plant Name", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "netPrice", label: "Unit Price", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "RATE" },
  { id: "netPrice", label: "Net Price", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "RATE" },
  { id: "netValue", label: "Net Value", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "RATE" },
  { id: "netValue", label: "Net Order Value", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "RATE" },
  { id: "purchaseRequisition", label: "Purchase Requisition", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "hsnSacCode", label: "HSN Code", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "hsnSacCode", label: "SAC Code", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "deliveryDate", label: "Delivery Date", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "DATE" }
];

  if (UserObj?.role.name == "VENDOR") {
    _.remove(initialColumns, function (ele) {
      return (
        // ele.label == "Material Number" ||
        ele.id == "purchaseRequisition"
      );
    });
  }

const permissionInit = {
  "create": false,
  "read": false,
  "update": false,
  "delete": false
};
const permissionObjInit = {
  "PURCHASE_ORDER_LISTING": permissionInit,
  "PURCHASE_ORDER_DETAIL": permissionInit,
  "WITH_ESIGN": permissionInit,
  "ACCEPT_PO": permissionInit,
  "HOLD_PO": permissionInit,

  "REJECT_PO": permissionInit,
  "RELEASE": permissionInit,
  "UNDO_RELEASE": permissionInit,
  "TRACK_ORDER_PO": permissionInit,
  "DOWNLOAD_PO": permissionInit,
};

function PodetailService() {
  const { id } = useParams();
  let navigate = useNavigate();

  const [openextendvalidityremarksmodal, setOpenExtendValidityRemarksModal] =
    useState(false);

  const handleReset = () => {
    setActiveStep(0);
  };
  const [openpopdfpurchasemodal, setOpenPoPdfPurchaseModal] = useState(false);
  const [openpopdfpurchasesuccessmodal, setOpenPoPdfPurchaseSuccessModal] =
    useState(false);
  const [openpopdfpurchaserejectedmodal, setOpenPoPdfPurchaseRejectedModal] =
    useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [downloadEl, setdownloadEl] = React.useState(null);
  const [openapprovepurchasetModal, setOpenApprovePurchaseModal] =
    useState(false);
  const [openapprovesucessfullyModal, setOpenApproveSucessfullyModal] =
    useState(false);
  const [openholdModal, setOpenHoldModal] = useState(false);
  const [openaddmildstonemodals, setOpenAddMildStoneModals] = useState(false);
  const [openesignpdfmodal, setopenESignPdfModal] = useState(false);
  const [openmilestonesuccessfullymodal, setOpenMilestoneSuccessfullyModal] = useState(false);
  const [openapproveesign, setOpenApproveEsign] = useState(false);

  const [checked, setChecked] = React.useState(true);

  const [openholdsucessfullyModal, setOpenHoldSucessfullyModal] =
    useState(false);
  const [openrejectedModal, setOpenRejectedModal] = useState(false);
  const [openrejectedsucessfullyModal, setOpenRejectedSuccessfullyModal] =
    useState(false);
  const [openrreleasedModal, setOpenReleasedModal] = useState(false);
  const [openrreleasedsuccessfullyModal, setOpenReleasedSuccessfullyModal] =
    useState(false);

  const [confirmObj, setConfirmObj] = useState({});
  const [vendorDetails, setVendorDetails] = useState({});

  const requestPayloadInitials = {
    pageNumber: 1,
    pageSize: 10,
    sortArray: [],
    searchCriteria: [],
  };
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [requestPayload, setRequestPayload] = useState(requestPayloadInitials);
  const [filterText, setFilterText] = useState("");
  const [filterFormData, setFilterFormData] = useState("");
  const [columns, setColumns] = useState(initialColumns);
  const [actionMenuList, setActionMenuList] = useState([]);
  const [versionListArr, setVersionListArr] = useState([]);
  const [selectedVersion, setSelectedVersion] = useState("");

  const [secPOPermission, setSecPOPermission] = useState(permissionObjInit);

  const [poDetails, setPODetails] = React.useState({});
  const [poProductsListing, setPOProductsListing] = React.useState({
    totalPages: 0,
    currentPage: 1,
    totalItems: 0,
    products: [],
  });

  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });
  const [trackOrderData, setTrackOrderData] = useState("");

  useEffect(() => {
    getPODetails(id, "", "initials");
    let secPOPermissionInit = _.cloneDeep(secPOPermission);
    let obj = {};
    for (let key in secPOPermissionInit) {
      // console.log(key, getSecPermission(key, "PURCHASE_ORDER"));
      
      obj[key] = getSecPermission(key, "PURCHASE_ORDER");
    }
    // console.log(obj);
    
    setSecPOPermission(obj);

    if (UserObj?.role.name == "VENDOR") {
      getVendorDetails();
    }
  }, []);

  const handleCloseAlert = (event, reason) => {
    setAlertComponent({ ...alertComponent, open: false });
  };

  const getVendorDetails = (url) => {
    setIsLoading(true);
    vendorServices
      .getVendorDetails()
      .then(function (response) {
        if (response?.data?.success == true) {
          setVendorDetails(response?.data?.data);
        }
      })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  const getPODetails = (param, versionNum, callingType) => {
    setIsLoading(true);
    let url = `/${param}`;
    if (!isEmptyDash(versionNum)) {
      url += `?version=${versionNum}`;
    }
    let promise = purchaseOrderServices.getPurchaseOrderListing(url);
    promise.then((res) => {
      if (res.data.success === true) {
        let columnsInit = _.cloneDeep(columns);
        let menuArr = [];
        let versionArr = [];
        if (callingType == "initials") {
          for (let i = 0; i <= res?.data?.data?.version; i++) {
            if (i == res?.data?.data?.version) {
              versionArr.push({"label": i,"value": ""});              
            }
            else {
              versionArr.push({"label": i,"value": i});
            }
          }
          // console.log(versionArr);
          setVersionListArr(versionArr);
        }

        if (res.data.data.poCategory == "Service") {
          _.remove(columnsInit, function (ele) {
            return (
              ele.label == "Material Number" ||
              ele.label == "Material Description" ||
              ele.label == "Net Price" ||
              ele.label == "Net Order Value" ||
              ele.label == "HSN Code"
            );
          });
        }

        if (res.data.data.poCategory == "Supply") {
          _.remove(columnsInit, function (ele) {
            return (
              ele.label == "Service Number" ||
              ele.label == "Service Description" ||
              ele.label == "Unit Price" ||
              ele.label == "Net Value" ||
              ele.label == "SAC Code"
            );
          });
        }
        
        let secPOPermissionInit = _.cloneDeep(secPOPermission);
        let permissionObj = {};
        for (let key in secPOPermissionInit) {
          permissionObj[key] = getSecPermission(key, "PURCHASE_ORDER");
        }
        if (userRole != "VENDOR") {
          // console.log(permissionObj , res.data.data.status);
          if ( (permissionObj["WITH_ESIGN"]?.read == true) && res.data.data.status == "Released from SAP") {          
            menuArr.push({lable: "Request Sign", onClickType: "Add_Milestone", onClickPaam: true})
          }
          
          if ( (permissionObj["RELEASE"]?.read == true) && res.data.data.status == "Sign Requested") {
            menuArr.push({lable: "Release", onClickType: "Open_Confirmation_Modal", onClickPaam: "Release"})
          }
          
          if ( (permissionObj["UNDO_RELEASE"]?.read == true) && res.data.data.status == "Released to Vendor") {
            menuArr.push({lable: "Undo Release", onClickType: "Open_Confirmation_Modal", onClickPaam: "Undo Release"})
          }
        }

        if (userRole == "VENDOR") {
          if ( (permissionObj["ACCEPT_PO"]?.read == true) && res.data.data.status == "Pending") {
            menuArr.push({lable: "Accept", onClickType: "Open_Confirmation_Modal", onClickPaam: "Accept"})
          }
          
          if ( (permissionObj["REJECT_PO"]?.read == true) && res.data.data.status == "Pending") {
            menuArr.push({lable: "Reject", onClickType: "Open_Confirmation_Modal", onClickPaam: "Reject"})
          }
          
        }
        // console.log(menuArr);
        
        setActionMenuList(menuArr);
        setPODetails(res.data?.data);
        setColumns(columnsInit);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }

  useEffect(() => {
    getPOProductsListing(requestPayload, filterText, filterFormData, selectedVersion);
  }, [requestPayload]);

  const getPOProductsListing = (requestPayloadParam, filterTextParam, formData, versionNum) => {
    setIsLoading(true);
    let param = `?page=${requestPayloadParam?.pageNumber}&pageSize=${requestPayloadParam?.pageSize}&search=${filterTextParam}`;
    if (requestPayloadParam.sortArray?.length > 0) {
      param += `&sortBy=${requestPayloadParam.sortArray[0]}&sortOrder=${requestPayloadParam.sortArray[1]}`;
    }
    const filteredFormData = formData ? Object.entries(formData)
      .filter(([key, value]) => value !== '')
      .reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
      }, {}) : {};
    if (filteredFormData && Object.keys(filteredFormData)?.length > 0) {
      Object.entries(filteredFormData).forEach(([key, value]) => {
        param += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
      });
    }

    if (!isEmptyDash(versionNum)) {
      param += `&version=${versionNum}`;
    }
    let promise = purchaseOrderServices.getPOProductsListing(id, param);
    promise.then((res) => {
      if (res.data.success === true) {
        setPOProductsListing(res?.data?.data);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };


  const onSortChange = (index, sortBy, sortOrder) => {
    let requestPayloadInit = _.cloneDeep(requestPayload);
    let columnsInit = _.cloneDeep(columns);
    let newSortLael = (sortOrder == "asc") ? "desc" : "asc";
    requestPayloadInit.sortArray = [sortBy, newSortLael];
    requestPayloadInit.pageNumber = 1;

    for (let i = 0; i < columnsInit?.length; i++) {
      columnsInit[i].sortLabel = "";
      if (i == index) {
        columnsInit[i].sortLabel = newSortLael;
      }
    }

    setRequestPayload(requestPayloadInit);
    setColumns(columnsInit);
  }

  const onPaginationChange = (e, value) => {
    let requestPayloadInit = _.cloneDeep(requestPayload);
    requestPayloadInit.pageNumber = value;
    setRequestPayload(requestPayloadInit);
  }

  const onPageSizeChange = (e) => {
    let { value } = e.target;
    let requestPayloadInit = _.cloneDeep(requestPayload);
    requestPayloadInit.pageSize = value;
    requestPayloadInit.pageNumber = 1;
    setRequestPayload(requestPayloadInit);
  }

  const onColumnInputChange = (value, index, sortBy, sortOrder) => {
    let columnsInit = _.cloneDeep(columns);
    columnsInit[index].inputText = value;
    setColumns(columnsInit);

    let formDataObj = {};
    for (let i = 0; i < columnsInit?.length; i++) {
      if (!isEmptyDash(columnsInit[i].inputText)) {
        formDataObj[columnsInit[i].id] = columnsInit[i].inputText;
      }
    }
    debouncedSearch(formDataObj);
  }

  const debouncedSearch = useCallback(
    _.debounce((searchTerm) => {
      let requestPayloadInit = _.cloneDeep(requestPayload);
      requestPayloadInit.pageNumber = 1;
      getPOProductsListing(requestPayloadInit, filterText, searchTerm, selectedVersion);
    }, 800),
    []
  );
  const [activeStep, setActiveStep] = React.useState(0);
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const download = Boolean(downloadEl);
  const handleClicks = (event) => {
    setdownloadEl(event.currentTarget);
  };
  const handleCloses = () => {
    setdownloadEl(null);
  };
  const userRole = UserObj ? UserObj?.role?.name : "";
  const reducer = (state, action) => {
    switch (action.type) {
      case "TOGGLE_DRAWER":
        return { ...state, open: action.newOpen };
      default:
        throw new Error(`Unknown action: ${action.type}`);
    }
  };
  const [state, dispatch] = React.useReducer(reducer, { open: false });

  const toggleDrawer = (newOpen) => () => {
    dispatch({ type: "TOGGLE_DRAWER", newOpen });
  };

  const handleChangeswich = (event) => {
    setChecked(event.target.checked);
  };

  const openConfirmModal = (param) => {
    let obj = {};
    obj["id"] = param;
    if (param == "header") {
      obj["text"] = "Header Level Excel";
    }
    if (param == "line-item") {
      obj["text"] = "Line Item Level Excel";
    }
    if (param == "po-pdf") {
      obj["text"] = "PO PDF";
    }
    setConfirmObj(obj);
    setOpenPoPdfPurchaseModal(true);
  }

  const closeConfirmModal = (param) => {
    setConfirmObj({});
    setOpenPoPdfPurchaseModal(false);
  }

  const downloadPO = () => {
    setIsLoading(true);
    let bodyData = {
      "poNumber": poDetails?.poNumber,
      "type": confirmObj?.id, // "line-item", header, po-pdf
    };
    let fileName = "";
    if (confirmObj?.id == "header") {
      fileName = `${poDetails?.poNumber}_HerderLevelExcel.xlsx`;
    }
    if (confirmObj?.id == "line-item") {
      fileName =  `${poDetails?.poNumber}_LineItemExcel.xlsx`;
    }
    if (confirmObj?.id == "po-pdf") {
      fileName = `${poDetails?.poNumber}_PO_PDF.pdf`;
    }
    const data = {
      url: `/v1/common/purchase-orders/download`,
      bodyData: bodyData,
      method: "POST",
      fileName: fileName
    };
    downloadFile(data)
      .then(response => {
        if (isEmptyDash(response)) {
          setOpenPoPdfPurchaseSuccessModal(true);         
        } else {        
          setAlertComponent({ open: true, type: "success", message: `${response?.data?.message}` });          
        }
      })
      .catch(error => {
        setAlertComponent({ open: true, type: "error", message: `There is some error to download file. ` });
      })
      .finally(() => {
        setIsLoading(false);
        setOpenPoPdfPurchaseModal(false);
      })
  }

  const openConfirmActionModal = (param) => {
    let obj = {};
    obj["id"] = param;
    if (param == "Accept") {
      obj["text"] = "Accept";
      setConfirmObj(obj);
      openPdfPreview();
    }
    if (param == "Release") {
      obj["text"] = "Release";
      setConfirmObj(obj);
      setOpenReleasedModal(true);
    }
    if (param == "Undo Release") {
      obj["text"] = "Undo Release";
      setConfirmObj(obj);
      setOpenRejectedModal(true);
    }
    if (param == "Reject") {
      obj["text"] = "Reject";
      setConfirmObj(obj);
      setOpenRejectedModal(true);
    }
  }

  const closeConfirmActionModal = (param) => {
    // setConfirmObj({});
    setOpenRejectedModal(false);
  }

  const poTakeAction = () => {
    setIsLoading(true);
    let bodyData = {
      "action": confirmObj?.id, //"Release", "Undo Release", "Reject"
      "purchaseOrderIds": [id]
    };
    poTakeActionAPICall(bodyData);
  }

  const poTakeActionAPICall = (bodyData) => {
    purchaseOrderServices.poTakeAction(bodyData)
      .then(response => {
        if (confirmObj?.id == "Release") {
          setOpenReleasedModal(false)
          setOpenReleasedSuccessfullyModal(true);
          // getPODetails(id);
          getPODetails(id, selectedVersion, "");
        } else if (confirmObj?.id == "Reject") {
          setOpenReleasedModal(false);
          setOpenRejectedSuccessfullyModal(true);
          // getPODetails(id);
          getPODetails(id, selectedVersion, "");
        } else if (confirmObj?.id == "Accept") {
          closePdfPreview();
          setOpenRejectedSuccessfullyModal(true);
          // getPODetails(id);
          getPODetails(id, selectedVersion, "");
        } else if (confirmObj?.id == "Undo Release") {
          setOpenRejectedSuccessfullyModal(true);
          // getPODetails(id);
          getPODetails(id, selectedVersion, "");
        }
        else {
          // setOpenPoPdfPurchaseSuccessModal(true);
          setAlertComponent({ open: true, type: "error", message: `Status has been changed for this PO. ` });
        }
      })
      .catch(error => {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}. ` });
      })
      .finally(() => {
        setIsLoading(false);
        closeConfirmActionModal();
      });
  }

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const uploadFile = (selectedFileParam) => {
    // e.preventDefault();
    let formData = new FormData();
    formData.append("file", selectedFileParam);
    setIsLoading(true);
    onboardingServices
      .uploadFile(formData)
      .then(function (response) {
        if (response?.data?.success === true) {

          let bodyData = {
            "action": confirmObj?.id, //"Release", "Undo Release", "Reject"
            "poPdf": { // required in case action is Release
              "key": encodeKey(response?.data?.data?.data?.Key),
              "fileName": selectedFileParam?.name,
            },
            "purchaseOrderIds": [id]
          };
          poTakeActionAPICall(bodyData);
        }
      })
      .catch(function (error) {
        setAlertComponent(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };
  const encodeKey = (key) => {
    if (!key) return key;
    return encodeURIComponent(key);
  };


  const openRequestSign = () => {
    setOpenAddMildStoneModals(true);
  };

  const closeRequestSign = () => {
    setOpenAddMildStoneModals(false);
  };

  const submitSign = (bodyData) => {
    setIsLoading(true);
    purchaseOrderServices.poAddMileStones(bodyData)
      .then(response => {
        if (response?.data?.success == true) {
          setAlertComponent({ open: true, type: "success", message: `Milestone added successfully.` });
          closeRequestSign();
          // getPODetails(id);
          getPODetails(id, selectedVersion, "");
        }
      })
      .catch(error => {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}. ` });
      })
      .finally(() => {
        setIsLoading(false);
        closeConfirmActionModal();
      });

  };

  const openPdfPreview = () => {
    setopenESignPdfModal(true);
  };

  const closePdfPreview = () => {
    setopenESignPdfModal(false);
  };

  const submitPdfPreview = () => {
    setIsLoading(true);
    let bodyData = {
      "action": confirmObj?.id, //"Release", "Undo Release", "Reject"
      "purchaseOrderIds": [id]
    };
    poTakeActionAPICall(bodyData);
  };

  const openReleaseModal = () => {
    setOpenReleasedModal(true);
  };

  const closeReleaseModal = () => {
    setOpenReleasedModal(false);
  };

  const handleTrackOrder = () => {
    setIsLoading(true);
    purchaseOrderServices.getPOTrackOrder(id)
      .then(response => {
        if (response?.data?.success == true) {
          toggleDrawer(true)();
          setTrackOrderData(response?.data?.data);
        }
      })
      .catch(error => {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}. ` });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const onSelectChange = (value) => {    
    setSelectedVersion(value);
    getPODetails(id, value, "");
    getPOProductsListing(requestPayloadInitials, filterText, "", value);
  }


  const DrawerList = (
    <TrackOrder steps={trackOrderData} close={() => toggleDrawer(false)()} refresh={() => handleTrackOrder()} />
  );
  return (
    <>
      <div className="login-forms">
        <div className="text-centers">
          <div className="search_filter_outerse ms-auto">
            <div className="search_main">
              <h5>PO Detail</h5>
            </div>
            <div className="create_listing_project">
                <div className="d-flex">
                  <span style={{marginRight: "10px", marginTop: "4px"}}>Version: </span>
                  <select 
                    value={selectedVersion}
                    onChange={(e) => onSelectChange(e.target.value)}
                    className="form-select vendor_lr_dashboard" 
                    aria-label="Default select example" 
                    fdprocessedid="v0ghl">
                      {versionListArr?.map((versionData, i) => <>
                        <option value={versionData?.value}>{versionData?.label}</option>
                      </>)}
                  </select>
                </div>
                
              {(actionMenuList.length > 0) && <div>
                <button
                  className="vendor_btn_bpdt_react_divs vendor_maine_contents"
                  id="basic-button"
                  aria-controls={open ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClick}
                >
                  <LayersIcon />
                  Action
                </button>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
                  {/* {userRole === "MANAGER" ? (
                    <MenuItem onClick={() => openConfirmActionModal("Accept")}>
                      Approve
                    </MenuItem>
                  ) : null} */}
                  {
                    actionMenuList.map((actionData, i) => <>
                      <MenuItem 
                      onClick={() => (actionData?.onClickType =="Add_Milestone") ? setOpenAddMildStoneModals(actionData?.onClickPaam) : openConfirmActionModal(actionData?.onClickPaam)}
                      >
                        {actionData?.lable}
                        </MenuItem>
                    </>)
                  }
                  {/* {(secPOPermission["WITH_ESIGN"]?.read == true) ? (
                    <MenuItem onClick={() => setOpenAddMildStoneModals(true)}>Request Sign</MenuItem>
                  ) : null}
                  {(secPOPermission["REJECT_PO"]?.read == true) ? (
                    <MenuItem onClick={() => openConfirmActionModal("Reject")}>Reject</MenuItem>
                  ) : null}
                  {(secPOPermission["ACCEPT_PO"]?.read == true) ? (
                    <MenuItem onClick={() => openConfirmActionModal("Accept")}>Accept</MenuItem>
                  ) : null}
                  {(secPOPermission["RELEASE"]?.read == true) ? (
                    <MenuItem onClick={() => openConfirmActionModal("Release")}>Release</MenuItem>
                  ) : null}
                  {(secPOPermission["UNDO_RELEASE"]?.read == true) ? (
                    <MenuItem onClick={() => openConfirmActionModal("Undo Release")}>Undo Release</MenuItem>
                  ) : null} */}
                  
                </Menu>
              </div>}
              <div className="track_order_react_row">
                <button
                  // onClick={toggleDrawer(true)}
                  onClick={handleTrackOrder}
                  class="vendor_btn vendor_maine_contents"
                >
                  Track Order
                </button>

                <Drawer
                  anchor="right"
                  open={state.open}
                  onClose={toggleDrawer(false)}
                  style={{ zIndex: 99999 }}
                >
                  {DrawerList}
                </Drawer>
              </div>
              <div>
                <button
                  className="vendor_btn_bpdt_react_divs vendor_maine_contents"
                  id="basic-button"
                  aria-controls={download ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={download ? "true" : undefined}
                  onClick={handleClicks}
                >
                  <FileDownloadIcon />
                  Download
                </button>
                <Menu
                  id="basic-menu"
                  anchorEl={downloadEl}
                  open={download}
                  onClose={handleCloses}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
                  <MenuItem onClick={() => openConfirmModal("header")}>
                    Header Level Excel
                  </MenuItem>
                  <MenuItem onClick={() => openConfirmModal("line-item")}>
                    Line Item Level Excel
                  </MenuItem>
                  <MenuItem onClick={() => openConfirmModal("po-pdf")} >
                    PO PDF
                  </MenuItem>
                </Menu>
              </div>
              <Link to="/admin/buyer-purchaseOrder" style={{ textDecoration: "none" }}>
              <button className="btn btn-danger">Back</button>
              </Link>             
            </div>
          </div>
          <div className="main_row1_podetail_service_cvdsblock_body">
            <div className="first_podetail_basic_block_level_reacts">
              <div className="lets_react_order_listing_level_buyer">
                <div className="content_react_level_details">
                  <img src={podetailImage} alt="" />
                  <p className="lets_block_react_details_purchase">
                    PO Number : <Tooltip title={poDetails?.poNumber}>{trimString(poDetails?.poNumber, 20)}
                    </Tooltip>
                  </p>
                </div>
                <div className="lets_pending_react_body">
                  Order Date :
                  <span className="date_solutions"> {strToDate(poDetails?.orderDate)} </span>
                  <div className="solution_asen_statsu_pending">
                    Status :<p className="date_solutions_status">{poDetails?.status}</p>
                  </div>
                </div>
              </div>

              <div className="lets_table_buyername_react_suntech">
                <table>
                  {(userRole != "VENDOR") && <tr>
                    <td className="name_asn_details_suntech_react_id">
                      SAP PO Number
                    </td>
                    <td>:</td>
                    <td>{poDetails?.sapPoCode}</td>
                  </tr>}
                  <tr>
                    <td className="name_asn_details_suntech_react_id">
                      Vendor Number
                    </td>
                    <td>:</td>
                    <td>
                    <Tooltip title={poDetails?.vendorCode}>{trimString(poDetails?.vendorCode, 20)}
                    </Tooltip>
                    </td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react_id">
                      Vendor Name
                    </td>
                    <td>:</td>
                    <td className="project_bobt_name_tooltip_wraprow">
                      <Tooltip title={poDetails?.vendorName}>{trimString(poDetails?.vendorName, 20)}
                      </Tooltip>
                      </td>
                  </tr>
                  {(userRole != "VENDOR") && <tr>
                    <td className="name_asn_details_suntech_react_id">
                      PO Category
                    </td>
                    <td>:</td>
                    <td> 
                      <Tooltip title={poDetails?.poType}>{trimString(poDetails?.poType, 20)}
                        </Tooltip>
                        </td>
                  </tr>}
                  <tr>
                    <td className="name_asn_details_suntech_react_id">Buyer</td>
                    <td>:</td>
                    <td>{poDetails?.buyerName}</td>
                  </tr>
                  {(userRole != "VENDOR") && <tr>
                    <td className="name_asn_details_suntech_react_id">
                      Company Code
                    </td>
                    <td>:</td>
                    <td>{poDetails?.companyCode}</td>
                  </tr>}
                  {(userRole != "VENDOR") && <tr>
                    <td className="name_asn_details_suntech_react_id">
                      Purchase Organisation
                    </td>
                    <td>:</td>
                    <td>{poDetails?.purchOrg}</td>
                  </tr>}
                  {(userRole != "VENDOR") && <tr>
                    <td className="name_asn_details_suntech_react_id">
                      Purchase Group
                    </td>
                    <td>:</td>
                    <td>{poDetails?.purchGrp}</td>
                  </tr>}
                  <tr>
                    <td className="name_asn_details_suntech_react_id">
                      Payment Terms
                    </td>
                    <td>:</td>
                    <td>{poDetails?.paymentTerms}</td>
                  </tr>
                </table>
                <table>
                {(userRole != "VENDOR") && <tr>
                    <td className="name_asn_details_suntech_react_id">
                      Project Name
                    </td>
                    <td>:</td>
                    <td className="project_bobt_name_tooltip_wraprow"><Tooltip title={poDetails?.projectName}> {trimString(poDetails?.projectName, 20)}</Tooltip>
                    </td>
                  </tr>}
                  {(userRole != "VENDOR") && <tr>
                    <td>Package Name</td>
                    <td>:</td>
                    <td>{poDetails?.packageName}</td>
                  </tr>}
                  <tr>
                    <td>Contact Person Email</td>
                    <td>:</td>
                    <td>
                      <Tooltip title={poDetails?.contactPersonEmail}>{trimString(poDetails?.contactPersonEmail, 20)}
                      </Tooltip>
                      </td>
                  </tr>
                  <tr>
                    <td>Contact Person Name</td>
                    <td>:</td>
                    <td>
                    <Tooltip title={poDetails?.contactPersonName}>{trimString(poDetails?.contactPersonName, 20)}
                    </Tooltip>
                    </td>
                  </tr>
                  <tr>
                    <td>Contact Person Number</td>
                    <td>:</td>
                    <td>
                    <Tooltip title={poDetails?.contactPersonNumber}>{trimString(poDetails?.contactPersonNumber, 20)}
                    </Tooltip>
                    </td>
                  </tr>
                  <tr>
                    <td>Total Quantity</td>
                    <td>:</td>
                    <td>{poDetails?.totalQuantity}</td>
                  </tr>
                  <tr>
                    <td>Received Quantity</td>
                    <td>:</td>
                    <td>{poDetails?.deliveredQty}</td>
                  </tr>
                  <tr>
                    <td>Pending Quantity</td>
                    <td>:</td>
                    <td>{poDetails?.pendingQty}</td>
                  </tr>
                </table>
              </div>
            </div>
            <div className="second_podetail_basic_block_level_reacts">
              <div className="lets_react_order_listing_level_buyer">
                <div className="content_react_level_details">
                  <img src={summaryImage} alt="" />
                  <p className="lets_block_react_details_purchase">Summary</p>
                </div>
              </div>
              <div>
                <table>
                  <tr>
                    <td className="name_asn_details_suntech_react">
                      Gross Amount
                    </td>
                    <td>:</td>
                    {/* <td>₹ {totalInr(returnZero(poDetails?.grossAmount))}</td> */}
                    <td>{returnRateVal(poDetails?.grossAmount)}</td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react">Tax</td>
                    <td>:</td>
                    {/* <td>₹{totalInr(returnZero(poDetails?.tax))}</td> */}
                    <td>{returnRateVal(poDetails?.tax)}</td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react">Freight</td>
                    <td>:</td>
                    {/* <td>₹{totalInr(returnZero(poDetails?.freight))}</td> */}
                    <td>{returnRateVal(poDetails?.freight)}</td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react">Discount</td>
                    <td>:</td>
                    {/* <td>₹{totalInr(returnZero(poDetails?.discount))}</td> */}
                    <td>{returnRateVal(poDetails?.discount)}</td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react">
                      Net Value
                    </td>
                    <td>:</td>
                    {/* <td>₹{totalInr(returnZero(poDetails?.netValue))}</td> */}
                    <td>{returnRateVal(poDetails?.netValue)}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div className="listing_main listing_main_dragdropcontext_body">
          <table className="dragdropcontext_ondragend_block_arrow">
          <thead style={{ position: "sticky", top: "0", zIndex: 1 }}>
                <tr>
                  <th className="vendor_tabels">
                    {/* <input type="checkbox" /> */}
                  </th>
                  {columns.map((column, index) => (<>
                    <th className="vendor_tabels ">
                      <div className="PoDetailTableHeading">
                        <div className="d-flex">
                          <p>{column?.label}</p>
                          {(column.isSort == true) && <span onClick={(e) => onSortChange(index, column.id, column.sortLabel)} className="table-sort-ico">
                            {(column.sortLabel != "asc") && <img src={topArrow} />}
                            {(column.sortLabel == "asc") && <img src={topHighlightArrow} />}
                            {(column.sortLabel != "desc") && <img src={bottomArrow} />}
                            {(column.sortLabel == "desc") && <img src={bottomHighlightArrow} />}
                          </span>}
                        </div>

                        {(column?.isSearchInput) && <input
                          type="text"
                          class="form-control form-ha"
                          placeholder="Search"
                          onChange={(e) => onColumnInputChange(e.target.value, index, column.id, column.sortLabel)}
                          value={column?.inputText}
                        />}
                      </div>
                    </th>
                  </>))}
                  {/* <th className="vendor_tabels" colSpan={2}>
                    <div className="PoDetailTableHeading">
                      <p style={{ textAlign: "center" }}>Received Quantity</p>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "2rem",
                        }}
                      >
                        <p>Boxes</p>
                        <p>Pcs</p>
                      </div>
                    </div>
                    <img src="images/code.png" alt="" />
                  </th> */}

                </tr>
              </thead>
              <tbody style={{ overflowY: "scroll", width: "200px" }}>
                {poProductsListing?.products?.map((productData, i) => (<>
                  <tr className="maine_tr_vendor">
                    <td>
                      <input type="checkbox" />
                    </td>
                    {columns.map((column, j) => (column?.formate == "TEXT") ? <td> 
                      <Tooltip title={productData[column?.id]}>{trimString(productData[column?.id], 20)}</Tooltip> 
                      </td> : (column?.formate == "DATE") ? <td>
                        {strToDate(productData[column?.id])}
                      </td> : (column?.formate == "RATE") ? <td>
                        {returnRateVal(productData[column?.id])}
                      </td> : null)}
                  </tr>
                </>))}
                {/* <tr className="maine_tr_vendor">
                  <td>
                    <input type="checkbox" />
                  </td>

                  <td className="block_solar">43245</td>
                  <td>Steel Rods</td>
                  <td>Ton</td>
                  <td>5</td>
                  <td>2</td>
                  <td>5</td>
                  <td>2</td>
                  <td>5</td>
                  <td>Mumbai Plant</td>
                  <td>₹ 50,000</td>
                  <td>₹ 50,00,000</td>
                  <td>PRQ2001</td>
                  <td>7207</td>
                  <td>12-07-2024</td>
                </tr> */}
              </tbody>
            </table>
          </div>
          {poProductsListing?.products?.length > 0 && <>
            <div className="lets_pagination_package_listing_react">
              <div className="pagination_select_react_packagelr_detail">
                <select
                  className="form-select packagelrlisting from-hs"
                  onChange={onPageSizeChange}
                  value={requestPayload?.pageSize}
                >
                  <option value="10">10</option>
                  <option value="15">15</option>
                  <option value="20">20</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                </select>
                <span className="react_text_showing">
                  {` Showing rows ${Number(poProductsListing?.pageSize) * Number(poProductsListing?.currentPage - 1) + 1} to ${Number(poProductsListing?.pageSize) * Number(poProductsListing?.currentPage - 1) + Number(poProductsListing?.products?.length)} of ${poProductsListing?.totalItems}`}
                </span>
              </div>
              <Stack spacing={2}>
                <Pagination
                  count={poProductsListing?.totalPages}
                  page={poProductsListing?.currentPage}
                  onChange={onPaginationChange}
                  renderItem={(item) => (<>
                    <PaginationItem
                      className="pagination_react_listings"
                      slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                      {...item}
                    />
                  </>
                  )}
                />
              </Stack>
            </div>
          </>}
          {/* Approve Modal Buyer Po */}
          {userRole === "MANAGER" ? (
            <Modal
              open={openapprovepurchasetModal}
              onClose={() => setOpenApprovePurchaseModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style1} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenApprovePurchaseModal(false)}
                  ></button>
                </div>
                <div class="modal-bodys">
                  <p class="project_manager_bidding">
                    Are you sure you want to "<b>Approve</b>" selected purchase
                    order? PO No. :<b>00701</b> | PO Amount : <b>₹35,600</b>
                  </p>
                  <div className="all_btn_modal_listing">
                    <button
                      href="onboarding_status.html"
                      className="view_progresse"
                      onClick={() => {
                        setOpenApprovePurchaseModal(false);
                        setOpenApproveSucessfullyModal(true);
                      }}
                    >
                      Yes
                    </button>

                    <button
                      href="onboarding_status.html"
                      className="view_lsting"
                      onClick={() => setOpenApprovePurchaseModal(false)}
                    >
                      No
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
          ) : null}
          {/* Approve sucessfully Modal  */}
          {userRole === "MANAGER" ? (
            <Modal
              open={openapprovesucessfullyModal}
              onClose={() => setOpenApproveSucessfullyModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenApproveSucessfullyModal(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <form>
                    <div className="approvel_btn_successfully">
                      <img src={checkcircleImage} alt="" />
                      <p className="profile_react_block">
                        Selected PO has been "<b>Approved</b>" Successfully
                      </p>
                      <p className="profile_react_blocks">
                        PO No. : <b>07001 | </b>PO Amount :<b> ₹35,600 |</b> PO
                        Qty : <b>12</b>
                      </p>
                      <button
                        className="view_progresse"
                        onClick={() => setOpenApproveSucessfullyModal(false)}
                      >
                        Ok
                      </button>
                    </div>
                  </form>
                </div>
              </Box>
            </Modal>
          ) : null}
          {/* Hold Modal  */}
          {userRole === "BUYER" || userRole === "MANAGER" ? (
            <Modal
              open={openholdModal}
              onClose={() => setOpenHoldModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenHoldModal(false)}
                  ></button>
                </div>
                <div class="modal-bodys">
                  <p className="project_manager_bidding">
                    Are you sure you want to "<b>Hold</b>" selected purchase
                    order?
                  </p>
                  <p className="profile_react_blocks">
                    Total PO Selected : <b>15 |</b> PO Amount :<b> ₹35,600 </b>
                  </p>
                  <div className="all_btn_modal_listing">
                    <button
                      href="onboarding_status.html"
                      className="view_progresse"
                      onClick={() => {
                        setOpenHoldModal(false);
                        setOpenHoldSucessfullyModal(true);
                      }}
                    >
                      Yes
                    </button>

                    <button
                      href="onboarding_status.html"
                      className="view_lsting"
                      onClick={() => setOpenHoldModal(false)}
                    >
                      No
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
          ) : null}
          {/* Hold sucessfully Modal  */}
          {userRole === "BUYER" || userRole === "MANAGER" ? (
            <Modal
              open={openholdsucessfullyModal}
              onClose={() => setOpenHoldSucessfullyModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenHoldSucessfullyModal(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <form>
                    <div className="approvel_btn_successfully">
                      <img src={holdImage} alt="" />
                      <p className="profile_react_block">
                        Selected PO has been "<b>Hold</b>" Successfully
                      </p>
                      <p className="profile_react_blocks">
                        PO No. : <b>07001 | </b>PO Amount :<b> ₹35,600 |</b> PO
                        Qty : <b>12</b>
                      </p>
                      <button
                        className="view_progresse"
                        onClick={() => setOpenHoldSucessfullyModal(false)}
                      >
                        Ok
                      </button>
                    </div>
                  </form>
                </div>
              </Box>
            </Modal>
          ) : null}
          {/* Rejected Modal  */}
          {userRole === "BUYER" || userRole === "VENDOR" ? (
            <Modal
              open={openrejectedModal}
              onClose={closeConfirmActionModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={closeConfirmActionModal}
                  ></button>
                </div>
                <div class="modal-bodys">
                  <p className="project_manager_bidding">
                    Are you sure you want to "<b>{confirmObj?.text}</b>" this purchase
                    order?
                  </p>
                  {/* <p className="profile_react_blocks">
                    </b> PO Amount :<b> ₹35,600 </b>
                  </p> */}
                  <div className="all_btn_modal_listing">
                    <button
                      className="view_progresse"
                      onClick={poTakeAction}
                    >
                      Yes
                    </button>

                    <button
                      className="view_lsting"
                      onClick={closeConfirmActionModal}
                    >
                      No
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
          ) : null}
          {/* Reject sucessfully Modal  */}
          <Modal
            open={openrejectedsucessfullyModal}
            onClose={() => setOpenRejectedSuccessfullyModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenRejectedSuccessfullyModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="approvel_btn_successfully">
                    {(confirmObj?.text == "Reject") && <img src={rejectImage} alt="" />}
                    {(confirmObj?.text == "Accept") && <img src={checkcircleImage} alt="" />}
                    {(confirmObj?.text == "Release") && <img src={checkcircleImage} alt="" />}
                    {(confirmObj?.text == "Undo Release") && <img src={checkcircleImage} alt="" />}
                    <p className="profile_react_block">
                      PO has been "<b>{confirmObj?.text}</b>" successfully.
                    </p>
                    {/* <p className="profile_react_blocks">
                        PO No. : <b>07001 | </b>PO Amount :<b> ₹35,600 |</b> PO
                        Qty : <b>12</b>
                      </p> */}
                    <button
                      className="view_progresse"
                      onClick={() => setOpenRejectedSuccessfullyModal(false)}
                    >
                      Ok
                    </button>
                  </div>
                </form>
              </div>
            </Box>
          </Modal>
          {/* Released Successfully  Modal  */}
          {userRole === "BUYER" || userRole === "MANAGER" ? (
            <Modal
              open={openrreleasedsuccessfullyModal}
              onClose={() => setOpenReleasedSuccessfullyModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenReleasedSuccessfullyModal(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <form>
                    <div className="approvel_btn_successfully">
                      <img src={checkcircleImage} alt="" />
                      <p className="profile_react_block">
                        Purchase Order has been released successfully.
                      </p>
                      {/* <p className="profile_react_blocks">
                        Total PO Selected. : <b>15 |</b> PO Updated :<b>15</b>
                      </p>
                      <p className="profile_react_blocks">
                        PO Total Amount : <b>₹35,600 |</b> PO Total Qty :{" "}
                        <b>12</b>
                      </p> */}
                      <button
                        className="view_progresse"
                        onClick={() => setOpenReleasedSuccessfullyModal(false)}
                      >
                        Ok
                      </button>
                    </div>
                  </form>
                </div>
              </Box>
            </Modal>
          ) : null}
          {/* PO PDF Modal Buyer Po */}
          <Modal
            open={openpopdfpurchasemodal}
            onClose={closeConfirmModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={closeConfirmModal}
                ></button>
              </div>
              <div class="modal-bodys">
                <p class="project_Manager_bidding">
                  Are you sure you want to download {confirmObj?.text}
                  <br />
                  <b>PO No. : {poDetails?.poNumber} </b>
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={downloadPO}
                  >
                    Yes
                  </button>
                  <button
                    href="onboarding_status.html"
                    className="view_lsting"
                    onClick={closeConfirmModal}
                  >
                    No
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
          {/* PO PDF Successfully Modal Buyer Po */}
          {userRole === "BUYER" || userRole === "MANAGER" ? (
            <Modal
              open={openpopdfpurchasesuccessmodal}
              onClose={() => setOpenPoPdfPurchaseSuccessModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style1} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenPoPdfPurchaseSuccessModal(false)}
                  ></button>
                </div>
                <div class="modal-bodys">
                  <img src={checkImage} alt="" />
                  <p class="project_Manager_bidding">
                    Selected "<b>{confirmObj?.text}</b>" file has been downloaded successfully.
                    <br />
                    <b>PO No. : {poDetails?.poNumber} </b>
                  </p>
                  <div className="all_btn_modal_listing">
                    <button
                      href="onboarding_status.html"
                      className="view_progresse"
                      onClick={() => {
                        setOpenPoPdfPurchaseSuccessModal(false);
                      }}
                    >
                      OK
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
          ) : null}
          {/*Extend Validity PO Modal  */}
          {/* {userRole === "BUYER" || userRole === "MANAGER" ? (
            <Modal
              open={openextendvalidityremarksmodal}
              onClose={() => setOpenExtendValidityRemarksModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box
                sx={extendvaliditystyle1}
                className="modal_react_controlpanel_employees"
              >
                <div className="modal-headeres">
                  <h1 className="modal-title fs-5" id="exampleModalLabel">
                    Extend Validity
                  </h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenExtendValidityRemarksModal(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <div
                    className="listing_main"
                    style={{
                      overflowY: "scroll",
                      height: "40vh",
                    }}
                  >
                    <table>
                      <thead>
                        <tr>
                          <th
                            colSpan={1}
                            className="vendor_tabels lets_table_blocklist_react_order"
                          >
                            <p>PO No.</p>
                          </th>
                          <th
                            colSpan={2}
                            className="vendor_tabels lets_table_blocklist_react_order"
                          >
                            <p>Current Validity</p>
                          </th>
                          <th
                            colSpan={2}
                            className="vendor_tabels lets_table_blocklist_react_order"
                          >
                            <p>New Validity</p>
                          </th>
                          <th
                            colSpan={1}
                            className="vendor_tabels lets_table_blocklist_react_order"
                          >
                            <div className="remarks_bdbt_div_react_validity">
                              <p>
                                Remarks <span className="error">*</span>{" "}
                              </p>
                              <ContentCopyIcon />
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <thead>
                        <tr>
                          <th className="vendor_tabels lets_table_blocklist_react_order">
                            <p className="product_list_id_react_buyer"></p>
                          </th>
                          <th className="vendor_tabels lets_table_blocklist_react_order">
                            <p className="product_list_id_react_buyer">From</p>
                          </th>
                          <th className="vendor_tabels lets_table_blocklist_react_order">
                            <p className="product_list_id_react_buyer">To</p>
                          </th>
                          <th className="vendor_tabels lets_table_blocklist_react_order">
                            <p className="product_list_id_react_buyer">From</p>
                          </th>
                          <th className="vendor_tabels lets_table_blocklist_react_order">
                            <p className="product_list_id_react_buyer">To</p>
                          </th>
                          <th className="vendor_tabels lets_table_blocklist_react_order">
                            <p className="product_list_id_react_buyer"></p>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00701
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-01-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-02-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            {" "}
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td>
                            <textarea
                              name="Message"
                              id="address"
                              class="form-control message-body_bbdt"
                              spellcheck="false"
                              placeholder="Enter the Fields"
                              style={{ height: "2vh" }}
                            ></textarea>
                          </td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00702
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-02-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-03-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            {" "}
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td>
                            <textarea
                              name="Message"
                              id="address"
                              class="form-control message-body_bbdt"
                              spellcheck="false"
                              placeholder="Enter the Fields"
                              style={{ height: "2vh" }}
                            ></textarea>
                          </td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00703
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-03-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-04-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            {" "}
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td>
                            <textarea
                              name="Message"
                              id="address"
                              class="form-control message-body_bbdt"
                              spellcheck="false"
                              placeholder="Enter the Fields"
                              style={{ height: "2vh" }}
                            ></textarea>
                          </td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00704
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-05-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-06-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            {" "}
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td>
                            <textarea
                              name="Message"
                              id="address"
                              class="form-control message-body_bbdt"
                              spellcheck="false"
                              placeholder="Enter the Fields"
                              style={{ height: "2vh" }}
                            ></textarea>
                          </td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00705
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-06-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-02-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            {" "}
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td>
                            <textarea
                              name="Message"
                              id="address"
                              class="form-control message-body_bbdt"
                              spellcheck="false"
                              placeholder="Enter the Fields"
                              style={{ height: "2vh" }}
                            ></textarea>
                          </td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00706
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-07-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-08-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            {" "}
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td>
                            <textarea
                              name="Message"
                              id="address"
                              class="form-control message-body_bbdt"
                              spellcheck="false"
                              placeholder="Enter the Fields"
                              style={{ height: "2vh" }}
                            ></textarea>
                          </td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00707
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-04-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-07-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            {" "}
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td>
                            <textarea
                              name="Message"
                              id="address"
                              class="form-control message-body_bbdt"
                              spellcheck="false"
                              placeholder="Enter the Fields"
                              style={{ height: "2vh" }}
                            ></textarea>
                          </td>
                        </tr>
                        <tr className="maine_tr_vendor">
                          <td className="lets_table_blocklist_react_order">
                            00708
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-08-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            12-09-2024
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td className="lets_table_blocklist_react_order">
                            {" "}
                            <input
                              class="form-control form-haswe"
                              type="date"
                              id="fromDate"
                              name="from"
                              value=""
                            />
                          </td>
                          <td>
                            <textarea
                              name="Message"
                              id="address"
                              class="form-control message-body_bbdt"
                              spellcheck="false"
                              placeholder="Enter the Fields"
                              style={{ height: "2vh" }}
                            ></textarea>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="table_btn_failed_sucess_purchase">
                    <button
                      onClick={() => setOpenExtendValidityRemarksModal(false)}
                      className="view_success"
                    >
                      Discard
                    </button>
                    <button
                      onClick={() => setOpenExtendValidityRemarksModal(false)}
                      className="view_failed"
                    >
                      Save
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
          ) : null} */}

          {/*Extend Validity PO Modal  */}
        </div>
        
        <SupportChat
          vendorDetails={{ vendor: { _id: poDetails?.vendorId } }}
          isP2P={true}
          P2PData={{
            isActive: true,
            vendorName: poDetails?.vendorName,
            refType: "PO",
            referenceId: poDetails?._id,
          }}
        />

        <RequestSignModal
          isOpen={openaddmildstonemodals}
          openRequestSign={openRequestSign}
          closeRequestSign={closeRequestSign}
          purchaseOrderIds={id}
          poDetails={poDetails}
          submitSign={submitSign}
        />

        <PDFPreview
          isOpen={openesignpdfmodal}
          openRequestSign={openPdfPreview}
          closeRequestSign={closePdfPreview}
          purchaseOrderIds={id}
          poDetails={poDetails}
          submitSign={submitPdfPreview}
        />

        <POReleaseModal
          isOpen={openrreleasedModal}
          openRequestSign={openReleaseModal}
          closeReleaseModal={closeReleaseModal}
          purchaseOrderIds={id}
          poDetails={poDetails}
          submitRelease={uploadFile}
        />
      </div>
      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleCloseAlert}
      />
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => 99999999,//theme.zIndex.drawer + 1,
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}

export default PodetailService;
